import { createAsyncThunk } from "@reduxjs/toolkit";
import { getApi } from "../../../services/apiServices";
import { ALL_PRODUCTS } from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

/*---------------- Get All Products ---------------- */
export const AllProductsAPI = createAsyncThunk(
  "all_products/admin",
  async () => {
    try {
      const response = await getApi(ALL_PRODUCTS);
      return response;
    } catch (error) {
      console.log("Error All ProductsAPI", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
